import type { CredentialPanel } from './types';

/** `.env` file for the one-time credentials panel. Generated in the browser; never uploaded. */
export function envFile(p: CredentialPanel): string {
  return [
    `# Pryme service credentials — ${p.serviceId} (${p.environment})`,
    '# Keep this file on your backend only. Pryme cannot show PRYME_SECRET_KEY again.',
    '# The SDK reads everything else (API base, audience, Pryme\'s verification key) from it:',
    '#   createPryme({ serviceId: process.env.PRYME_SERVICE_ID, secretKey: process.env.PRYME_SECRET_KEY })',
    `PRYME_SERVICE_ID=${p.serviceId}`,
    `PRYME_SECRET_KEY=${p.secretKey}`,
    '',
  ].join('\n');
}

export function downloadText(filename: string, text: string, type = 'text/plain') {
  const url = URL.createObjectURL(new Blob([text], { type }));
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

export const pretty = (v: unknown) => (typeof v === 'string' ? v : JSON.stringify(v, null, 2));
